"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  Approval_BlockGuaranteeOrdering: "Blocks the consultant's guarantee and SPO sponsors from ordering on their behalf.",
  Approval_Contact: 'Approval for receiving info emails/SMS',
  Approval_MarketingConsultant: 'Approval for receiving emails/SMS from beauty consultant',
  Approval_MarketingExternal: 'Approval for receiving marketing information from external sources',
  Approval_MarketingOriflame: 'Approval for receiving marketing information from Oriflame',
  Approval_Newletters: 'Approval for receiving newsletters',
  Approval_PersonalData: 'Approval for displaying personal data',
  Approval_Publication: 'Approval for publication in Oriflame materials',
  Approval_UplineLeaderBrowse: 'Leader approval for up line Leader to browse leader downline members',
  Approval_UplineLeaderData: "Leader approval for up line Leader to display leader's data",
  BrowserTitle: 'VIP Customer Registration | Oriflame Cosmetics',
  BtnCancel: 'Cancel',
  BtnLeaving: 'Still leave',
  Custom_text: 'Market specific text about privacy policy and personal data processing for marketing products and services, analytical purposes and profiling. User is informed of their right to request access to data, rectification, deletion, transfer or limitation of processing and to raise objections. Link to more information about how Oriflame processes your personal data.',
  EmailPrimaryChannelDescription: 'Successfully connected! Please enter your email address and then verify it.',
  EmailPrimaryChannelLabel: 'Email',
  EmailPrimaryChannelPlaceholder: '@',
  EmailPrimaryChannelTitle: 'Email',
  EmailPrimaryChannelTooltip: 'Write your email in the format my@email.com',
  EmailVerification_Header: 'Verify your email',
  EmailVerification_ProceedingToRegistration: 'Proceeding to registration',
  EmailVerification_SendAgain: 'Send again',
  EmailVerification_Text: 'To continue with the registration please verify your email. A code was sent to {contactEmail}, you can enter it below.',
  EmailVerification_Verified: 'Verified',
  EmailVerification_WrongCode: 'Wrong code, try one more time or send again.',
  Error_WrongCode: 'Wrong code, try one more time or send again.',
  FirstStep_Address: 'Billing address',
  FirstStep_Button: 'NEXT',
  FirstStep_Country: 'Choose your country for billing',
  FirstStep_Country_Placeholder: 'Choose',
  FirstStep_Country_Tooltip: 'Please provide your country for shiping and taxation reasons.',
  FirstStep_DateOfBirth: 'Date of birth',
  FirstStep_DateOfBirthText: 'Enter your date of birth so we can surprise you with a special treat on your birthday!',
  FirstStep_Email: 'Email',
  FirstStep_Email_Optional: 'Email (optional)',
  FirstStep_FirstName: 'First name',
  FirstStep_Gender: 'Gender',
  FirstStep_Gender_Placeholder: 'Choose',
  FirstStep_Header: 'Personal details',
  FirstStep_LastName: 'Last name',
  FirstStep_Phone: 'Phone',
  FirstStep_PhoneWithPrefix: 'Mobile Phone',
  FirstStep_Phone_Optional: 'Phone (optional)',
  FirstStep_PlaceHolder: 'DD/MM/YYYY',
  FirstStep_PlaceholderEmail: '@',
  FirstStep_PlaceholderPhone: '+48XXXXXXXXX',
  FirstStep_PlaceholderPhoneWithPrefix: 'XXXXXXXXX',
  FirstStep_SearchedAddress: 'Searched address',
  FirstStep_Text: 'Start by filling out your account information.',
  FirstStep_TooltipPhone: 'Write your phone in the format +48XXXXXXXXX',
  FirstStep_TooltipPhoneWithPrefix: 'Write your phone in the format 123456789',
  FirstStep_UniqueId: 'Unique ID',
  FirstStep_UniqueId_Tooltip: 'Write your unique ID in the format 123456789',
  LegalDocument1_Link_Label: 'LegalDocument1 Link',
  LegalDocument2_Link_Label: 'LegalDocument2 Link',
  LegalDocument3_Link_Label: 'LegalDocument3 Link',
  LegalDocument4_Link_Label: 'LegalDocument4 Link',
  LegalDocument5_Link_Label: 'LegalDocument5 Link',
  LegalDocument6_Link_Label: 'LegalDocument6 Link',
  LegalDocument7_Link_Label: 'LegalDocument7 Link',
  LegalDocument8_Link_Label: 'LegalDocument8 Link',
  ModalLeavigInfo: 'Are you sure you want to close this page? You may lose some of the information you have already filled in.',
  ModalLeavingTitle: "You're leaving?",
  ParentalConsentCheckboxLabel: 'I am under {parentalConsentAge} years old',
  ParentalConsentDescription: 'If you are at least {minAge} years old but not yet {parentalConsentAge}, you can join Oriflame, but we need your parent’s consent.',
  ParentalConsentEmail: 'Email',
  ParentalConsentEmailPlaceholder: '@',
  ParentalConsentEmailTooltip: 'Write your email in the format my@email.com',
  ParentalConsentPendingExplore: 'Explore the website',
  ParentalConsentPendingPageDescription: 'You will become an Oriflame Member as soon your parent gives the consent. Tell your parent to read the SMS we’ve sent and accept it within the next 24 hours. Once they have confirmed, you will get a welcome message from us. If your parent does not accept, we will not be able to register you.',
  ParentalConsentPendingPageTitle: 'Registration pending',
  ParentalConsentPhone: 'Mobile phone',
  ParentalConsentPhoneWithPrefix: 'Mobile Phone',
  ParentalConsentPlaceholderPhone: 'XXXXXXXXX',
  ParentalConsentSameEmailValidation: 'The email for parental consent must be different from the contact email.',
  ParentalConsentSamePhoneValidation: 'The phone number for parental consent must be different from the contact phone number.',
  ParentalConsentTitle: 'Younger than {parentalConsentAge}?',
  ParentalConsentTooltipPhone: 'Write your phone in the format +48XXXXXXXXX',
  ParentalConsentTooltipPhoneWithPrefix: 'Write your phone in the format XXXXXXXXX',
  PhonePrimaryChannelDescription: 'Successfully connected! Please enter your mobile phone number and then verify it.',
  PhonePrimaryChannelLabel: 'Phone',
  PhonePrimaryChannelLabelWithPrefix: 'Mobile Phone',
  PhonePrimaryChannelPlaceholder: '+48XXXXXXXXX',
  PhonePrimaryChannelPlaceholderWithPrefix: 'XXXXXXXXX',
  PhonePrimaryChannelTitle: 'Phone',
  PhonePrimaryChannelTooltip: 'Write your phone in the format +48XXXXXXXXX',
  PhonePrimaryChannelTooltipWithPrefix: 'Write your phone in the format XXXXXXXXX',
  PhoneVerification_Header: 'Verify your phone',
  PhoneVerification_ProceedingToRegistration: 'Proceeding to registration',
  PhoneVerification_SendAgain: 'Send again',
  PhoneVerification_Text: 'To continue with the registration please verify your phone. A code was sent to {contactTelephone}, you can enter it below.',
  PhoneVerification_Verified: 'Verified',
  PhoneVerification_WrongCode: 'Wrong code, try one more time or send again.',
  Prestep_Apple: 'Sign up with Apple',
  Prestep_Button: "LET'S GET STARTED",
  Prestep_Email: 'Email',
  Prestep_ExternalAccountAlreadyConnected: 'External account already connected',
  Prestep_Facebook: 'Sign up with Facebook',
  Prestep_Google: 'Sign up with Google',
  Prestep_Header: 'Join us',
  Prestep_InvitationCode: 'Invitation code (optional)',
  Prestep_InvitationCodeNotFound: 'Invalid code',
  Prestep_InvitationCodeTitle: 'Add invitation code',
  Prestep_InvitationCodeTooltip: 'Add invitation code for a 5€ discount on your initial purchase over 45€.',
  Prestep_LegalNotice: 'You are starting a registration process as Oriflame VIP Customer. Please find our {PrivacyPolicy_Link} and {TermsAndConditions_Link}. By clicking on the buttons below, you consent to receive messages from Oriflame related to your registration process.',
  Prestep_LegalNotice_PrivacyPolicy_Label: 'Privacy policy',
  Prestep_LegalNotice_TermsAndConditions_Label: 'Terms and conditions',
  Prestep_Or: 'OR',
  Prestep_Password: 'Create a password',
  Prestep_Phone: 'Phone',
  Prestep_PhoneWithPrefix: 'Mobile Phone',
  Prestep_PlaceholderEmail: '@',
  Prestep_PlaceholderPassword: '******',
  Prestep_PlaceholderPhone: '+48XXXXXXXXX',
  Prestep_PlaceholderPhoneWithPrefix: 'XXXXXXXXX',
  Prestep_ReferralTitle: 'You were invited by',
  Prestep_RegistrationFailed: 'Registration failed. Please try again later.',
  Prestep_TooltipPhone: 'We will send a verification code',
  Prestep_TooltipPhoneWithPrefix: 'We will send a verification code',
  Prestep_UnauthorizedAccess: 'Unauthorized access',
  PrimaryChannelSubmitButton: 'NEXT',
  PrivacyPolicy_Label: 'Privacy policy',
  PrivacyPolicy_Text: 'I have read and accept the {PrivacyPolicy_Link}',
  Reseller: 'Reseller',
  SecondStep_BrandPartnerNumber: 'Brand Partner’s number',
  SecondStep_Button: 'NEXT',
  SecondStep_Button_Find: 'FIND',
  SecondStep_Country: 'Country',
  SecondStep_FindTheBestBrandPartner: 'Find the best Brand Partner for me',
  SecondStep_FindTheBestBrandPartner_Tooltip: 'Write your ZIP code and we will connect you with closest BP',
  SecondStep_Header: 'Connect to a Brand Partner',
  SecondStep_HeresYourBrandPartner: 'Here’s your Brand Partner!',
  SecondStep_IKnowaBrandPartner: 'I know a Brand Partner',
  SecondStep_SearchedAddress: 'Searched address',
  SecondStep_Text: 'Your Brand partner will be your main source of information and guidance for any inquiries you may have regarding our products, benefits and business opportunity.',
  SecondStep_YourAreConnected: 'You are connected to:',
  SecondStep_YourZipCode: 'Your zip code',
  SecondStep_YourZipCode_Tooltip: "Don't know a Brand Partner? We will find the best one based on your location.",
  SupportCenter: 'Support center',
  TermsAndConditions: 'I agree with {TermsAndConditions_Link}.',
  TermsAndConditions_Label: 'Terms and Conditions',
  ThirdStep_AddYourDocument: 'Add your documents',
  ThirdStep_AdditionalIDCard_Header: 'Additional ID Card',
  ThirdStep_AdditionalIDCard_Text: 'Optional text about Additional ID card',
  ThirdStep_Button: 'FINISH REGISTRATION',
  ThirdStep_Button_Continue_Payment: 'CONTINUE TO PAYMENT',
  ThirdStep_ChooseDocumentType: 'Choose document type',
  ThirdStep_Confirmation1: 'ThirdStep_Confirmation1',
  ThirdStep_Confirmation2: 'ThirdStep_Confirmation2',
  ThirdStep_DocumentDetails: 'Document details',
  ThirdStep_DocumentFileSize: 'Max 5 MB, jpg or png',
  ThirdStep_DocumentNumber: 'Document number',
  ThirdStep_DocumentNumber_Tooltip: 'ex. 123456789',
  ThirdStep_DocumentType: 'Document type',
  ThirdStep_Documents_Header: 'Documents',
  ThirdStep_ExpirationDate: 'Expiration date',
  ThirdStep_ExpirationDate_Tooltip: 'DD.MM.YYYY',
  ThirdStep_GeneralConditions: 'General conditions',
  ThirdStep_GeneralConditions_Text: 'By Completing this form you agree to Oriflame and/or your Sponsor sending you marketing and other materials related to your role as a Brand Partner. You can unsubscribe from marketing e-mails and texts at any time, free of charge, via ‘My Profile’, CONTACT US, or via a link in the emails you receive from us.',
  ThirdStep_Header: 'Almost there!',
  ThirdStep_HeaderText: 'One last thing before you begin a wonderful new journey.',
  ThirdStep_IDCard_Header: 'ID Card',
  ThirdStep_IDCard_Text: 'Optional text about ID card',
  ThirdStep_ImageGuidelines: 'Image guidelines',
  ThirdStep_KYCDocument_Header: 'KYC document',
  ThirdStep_KYCDocument_Text: 'Info about this document. You can upload multiple pages. Make sure they are good quality.',
  ThirdStep_More: 'More',
  ThirdStep_SelectFile: 'Select file',
  ThirdStep_ShowLess: 'Less',
  ThirdStep_ShowMore: 'More',
  ThirdStep_UploadDocument: 'Upload document',
  ThirdStep_UploadDocumentText: 'Info about this document. You can upload multiple pages. Make sure they are good quality.',
  ThirdStep_Your_Documents_Header: 'Your Documents',
  ThirdStep_Your_Documents_Text: 'Info about this section',
  Welcome_Button: 'START EXPLORING',
  Welcome_Header: 'Welcome!',
  Welcome_Text: 'Congratulations, you are on your way to a wonderful new journey!',
  addresResults: '({count} results)',
  addressSearch: 'Address search',
  addressSearchTooltip: 'Search for Zip and city',
  addressSearchValidation: 'You have to search for address',
  area: 'Area',
  area_Placeholder: 'Area placeholder',
  area_Tooltip: 'Area tooltip',
  back: 'BACK',
  birthDate_DoesntMatchUniqueId: 'Date of birth does not match your Unique ID',
  birthDate_LegalRequirementsFailed: 'You must be {MinAge} or older',
  birthDate_OutOfRange: 'Date of birth is not valid',
  cancel: 'Cancel',
  cannotCreate: 'Cannot create new item',
  cannotDelete: 'Cannot delete',
  cannotGetData: 'Cannot get data from server',
  cannotResend: 'Cannot resend',
  cannotUpdate: 'Cannot update',
  cannotVerify: 'Cannot verify',
  cannotVerifyCaptcha: 'Please verify captcha',
  city: 'City',
  city_Placeholder: 'City placeholder',
  confirm: 'Confirm',
  confirmDocumentDelete: 'Do you really want to delete this document?',
  country: 'Country',
  country_Placeholder: 'Country placeholder',
  customerServiceLinkLabel: 'customer service',
  customer_NotEligible: 'You are not eligible for customer upgrade.',
  customer_NotUnique: 'You cannot register at the moment. Please contact {customerServiceLink}.',
  delete: 'Delete',
  delivery: 'Delivery',
  delivery2: 'Delivery 2',
  delivery2_Placeholder: 'Delivery 2 placeholder',
  delivery2_Tooltip: 'Delivery 2 tooltip',
  delivery3: 'Delivery 3',
  delivery3_Placeholder: 'Delivery 3 placeholder',
  delivery3_Tooltip: 'Delivery 3 tooltip',
  delivery_Placeholder: 'Delivery placeholder',
  delivery_Tooltip: 'Delivery tooltip',
  district: 'District',
  district_Placeholder: 'District placeholder',
  document_ExpirationTooSoon: 'Your document will expire too soon.',
  errorOccured: 'An error occured',
  fileTypeIsNotSupported: 'File type is not supported. Try uploading jpg or png',
  genderLabelMan: 'Man',
  genderLabelOther: 'Other',
  genderLabelWoman: 'Woman',
  hide: 'Hide',
  history: 'History',
  locality: 'Locality',
  locality_Placeholder: 'Locality placeholder',
  loginLinkLabel: 'logging in',
  noSuggestions: 'No suggestions',
  optedOutOfSponsorSelect: 'optedOutOfSponsorSelect',
  orderHistory: 'orderHistory',
  oriflameApp: 'Oriflame app',
  oriflameAppInfo: 'Browse beauty and shop easily in our app',
  passwordRequirementCharactersCount: '{min}+ characters',
  passwordRequirementDigit: 'Numbers',
  passwordRequirementLetter: 'Letter',
  passwordRequirementLowerCaseLetter: 'Lower case letters',
  passwordRequirementSpecialCharacter: 'Special characters',
  passwordRequirementUpperCaseLetter: 'Upper case letters',
  province: 'Province',
  province_Placeholder: 'Province placeholder',
  readMore: 'Read more',
  region: 'Region',
  region_Placeholder: 'Region placeholder',
  resendInMinute: 'Resend code in 1 minute',
  searchForAnAddress: 'Search for an address',
  selectFile: 'Select file',
  selectedFileExceedsMaximumSize: 'File is too big, maximum size {maxMBs} MB',
  showImage: 'Show image',
  stateApproved: 'Approved',
  statePending: 'Pending',
  stateRejected: 'Rejected',
  stateUnknown: 'Unknown state',
  streetAddress: 'Street address',
  streetAddressTooltip: 'Type in full address with house/apartment number',
  streetAddress_Placeholder: 'Street address placeholder',
  successResend: 'Code was resent.',
  termsAndConditions_Mandatory: 'Terms and conditions have to be accepted.',
  titleContinueApp: 'Continue on the Oriflame App',
  uploadDone: 'Uploaded',
  uploading: 'Uploading...',
  validationBirthDateRegex: 'Birth date format should be {correctFormat}, e.g. 24.12.2000',
  validationDateRegex: 'Date format should be {correctFormat}, e.g. 24.12.2000',
  validationEmailIsAlreadyUsed: 'Email is already used. Try {loginLink} instead',
  validationEmailTerminatedCustomer: 'Cannot change email for terminated customer',
  validationLength: 'Invalid property length',
  validationMandatoryPropertyIsNull: 'This field is required',
  validationMaxLength: 'Maximum {max} characters',
  validationMaxValue: 'The date should not be later than {max}',
  validationMinLength: 'Minimum {min} characters',
  validationMinValue: 'The date should be later than {min}',
  validationRegex: 'This field is not filled in correctly',
  validationRegexBirthDate: 'Please enter your date of birth in the right format DD.MM.YYYY',
  validationRegexEmail: 'Please enter a valid email in the format my@mail.com',
  validationRegexIdentityCardDateExpiration: 'The date should not be later than {max}',
  validationRegexPhone: 'Please enter a valid phone in the format +46XXXXXXXXX',
  validationRegexUniqueID: 'Please enter a valid Unique ID in the format 123456',
  validationRequired: 'This field is required',
  validationUniqueAlias: 'Alias is already used',
  validationUniqueBankAccount: 'Bank account is already used',
  validationUniqueCustomerAttribute: 'Attribute is already used',
  validationUniqueDisplayName: 'Display name is already used',
  validationUniquePhone: 'Phone is already used. Try {loginLink} instead',
  validationUniqueTaxCode: 'Tax code is already used',
  validationUniqueTaxCode2: 'Tax code 2 is already used',
  validationUniqueUniqueId: 'Unique ID is already used',
  validationValidConfirmationCode: 'Confirmation code is not valid',
  validationValidOldPassword: 'Password does not match to existing password',
  validationValidPhone: 'Phone is not valid',
  validationValidSponsorNumber: 'Sponsor number is not valid',
  validationValidUniqueId: 'Unique ID is not valid',
  validationXmlCharacters: 'Property contains not supported character',
  warning: 'Warning',
  zipcode: 'Zip code',
  zipcode_Placeholder: 'Zip code placeholder'
};
const translationsNamespace = exports.translationsNamespace = 'simplified-registration-VIPCustomer';